import StarBreakdown from './StarBreakdown'

export default StarBreakdown
